import React from 'react';
import { faTimes } from '@fortawesome/pro-solid-svg-icons/faTimes';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default function TimesSolidIcon(props) {
  return <FontAwesomeIcon icon={faTimes} {...props} />;
}
